import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  ViewEncapsulation,
} from '@angular/core';
import type { ClassValue } from 'clsx';
import { mergeClasses } from 'src/app/@core/utils/merge-classes';

/**
 * Helm dialog footer component (spartan layer).
 * Provides a flex container for dialog action buttons.
 */
@Component({
  selector: 'hlm-dialog-footer, [hlmDialogFooter]',
  standalone: true,
  host: {
    '[class]': '_computedClass()',
  },
  template: '<ng-content />',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class HlmDialogFooterComponent {
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    mergeClasses(
      'flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2',
      this.userClass(),
    ),
  );
}
